import { render, staticRenderFns } from "./GerenciaCadastroHomologacaoPonto.vue?vue&type=template&id=1e24494d"
import script from "./GerenciaCadastroHomologacaoPonto.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroHomologacaoPonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports